import type { CardReading } from './recipes'

const NAMES: Record<keyof CardReading, string> = {
  title: 'the name',
  ingredients: 'ingredients',
  steps: 'steps',
  notes: 'notes',
}

const listed = (names: string[]) =>
  names.length < 2 ? (names[0] ?? '') : `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`

// What a card reading changes in the form: it only fills fields that are still empty, so nothing anyone typed is
// lost, and it says plainly what it filled and what it left alone.
export function mergeReading<F extends CardReading>(fields: F, words: Partial<CardReading>) {
  const keys = Object.keys(NAMES) as (keyof CardReading)[]
  const read = keys.filter((k) => words[k]?.trim())
  const filled = read.filter((k) => !fields[k].trim())
  const kept = read.filter((k) => fields[k].trim())
  const note =
    filled.length === 0
      ? kept.length
        ? 'Everything the card had was already filled in, so nothing was changed.'
        : 'No words could be read from the card. You can type it in instead.'
      : `Filled in ${listed(filled.map((k) => NAMES[k]))} from the card.` +
        (kept.length ? ` What you’d already typed in ${listed(kept.map((k) => NAMES[k]))} was kept.` : '') +
        ' Check every line against the card before you save. [?] marks a word that couldn’t be read.'
  return { fields: { ...fields, ...Object.fromEntries(filled.map((k) => [k, words[k]])) } as F, filled, note }
}
